import { Text } from '@genial/components';
import { BoxRadius, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Skeleton } from 'native-base';
import React, { useEffect } from 'react';
import { StyleSheet, View } from 'react-native';

interface ItemDateProps {
  updatedAtDto: string | null;
  updatedAtDynamic?: Date;
}

const styles = StyleSheet.create({
  container: {
    gap: Utils.Token.ToInt(Spacing, 'inline.quarck'),
  },
});

export const ItemDate: React.FC<ItemDateProps> = ({ updatedAtDto, updatedAtDynamic }) => {
  const [hasUpdate, setHasUpdate] = React.useState(false);
  const [animationFinished, setAnimationFinished] = React.useState(false);

  useEffect(() => {
    if (updatedAtDynamic) {
      setHasUpdate(true);
      setAnimationFinished(false);

      setTimeout(() => {
        setAnimationFinished(true);
      }, 1000);
    }
  }, [updatedAtDynamic]);

  return (
    <View style={styles.container}>
      <Text
        numberOfLines={1}
        ellipsizeMode="tail"
        fontSize={Typography['fontsize.md']}
        textAlign="start">
        {updatedAtDto}
      </Text>
      {hasUpdate && animationFinished && (
        <Text fontSize={Typography['fontsize.xs']} color="neutral.medium">
          Atualizado às&nbsp;
          {Utils.Mask.DateFormat(updatedAtDynamic, 'HH:mm:ss')}
        </Text>
      )}
      {hasUpdate && !animationFinished && (
        <Skeleton height={Spacing['inline.nano']} borderRadius={BoxRadius.xs} />
      )}
    </View>
  );
};
